$ = require('jquery');

module.exports = {
	init: function(payload) {
		$target = payload.$target;

		var $item = $('.js-menu-list').find('> li'),
			timer;

		$item.each(function() {

			var $this = $(this);

			$this.on('mouseenter', function() {

				if ($item.hasClass('is-active')) {

					if ($(this).find('.m-submenu').length > 0) {
						clearTimeout(timer);

						var $current = $(this);

						timer = setTimeout(function() {

							$item.removeClass('is-active');
							$current.addClass('is-active');
						}, 500);

					} else {
						timer = setTimeout(function() {
							$item.removeClass('is-active');
						}, 1000);
					}
				} else {
					$(this).addClass('is-active');
				}
			});

			$this.on('mouseleave', function() {
				clearTimeout(timer);
			});
		});

		$('.js-menu-list').on('mouseleave', function() {
			timer = setTimeout(function() {
				$item.removeClass('is-active');
			}, 1000);
		});
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/js/components/submenu.js
// module id = 26
// module chunks = 0